import LegacyLessonPage from "../legacyLessons/LessonPage";
import { releaseFeatures } from "@/config/releaseFeatures";
import React from "react";

type LessonPageProps = {
  title?: string;
  children: React.ReactNode;
};

function LessonPage({ children }: LessonPageProps) {
  return (
    <div className="flex justify-center w-full px-4 pb-8 md:px-4">
      <div id="lesson" className="w-full">
        {children}
      </div>
    </div>
  );
}

export default releaseFeatures.learning ? LessonPage : LegacyLessonPage;
